//codex-- Keep the toolbar redesign scoped to pages in this folder.
import PageToolbar, { ToolbarField } from './PageToolbar';
import React, { useState, useEffect } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import SearchBarCP from '../components/SearchBarCP';
import LegendCP from '../components/LegendCP';
import SubMenu from '../components/SubMenu';
import ModalWindow from '../components/ModalWindow';
import Truncate from '../components/Truncate';
import DateFormat from '../components/DateFormat';
// import { userData } from '../context/UserData';
import LoadingSpinner from '../components/LoadingSpinner';
import HeadingCp from '../components/HeadingCp';
import CurrencyFormat from '../components/CurrencyFormat';
import FileLocation from '../components/FileLocation';
import { ArrowPathIcon, PencilSquareIcon, PlusIcon } from '@heroicons/react/20/solid';
import MonthTabs from '../components/MonthTabs';
import Badge from '../components/Badge';
import ConfirmDeleteModal from '../components/ConfirmDeleteModal';
import { parse, format } from 'date-fns';
import TruncateNumber from '../components/TruncateNumber';

const ContractsPage = () => {
  // -- Hold modal -----------------------------
  const [showHoldModal, setShowHoldModal] = useState(false);
  const [holdContractId, setHoldContractId]   = useState(null);

  // <-- NEW: Pagination states
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
      
  const navigate = useNavigate();
  const [contracts, setContracts] = useState([]);
  const [filteredContracts, setFilteredContracts] = useState([]);
  
   // sorting
  const [dueSortDir, setDueSortDir] = useState('asc'); // 'asc' | 'desc'

  // --- SORT by next due date (NI|LI column) ---
  const sortedContracts = React.useMemo(() => {
    const arr = Array.isArray(filteredContracts) ? [...filteredContracts] : [];

    arr.sort((a, b) => {
      // contract.next_due_date is expected 'YYYY-MM-DD'
      const aTime = a?.next_due_date ? new Date(a.next_due_date).getTime() : Infinity;
      const bTime = b?.next_due_date ? new Date(b.next_due_date).getTime() : Infinity;

      // push invalid dates to bottom
      const safeATime = Number.isFinite(aTime) ? aTime : Infinity;
      const safeBTime = Number.isFinite(bTime) ? bTime : Infinity;

      return dueSortDir === 'asc'
        ? safeATime - safeBTime
        : safeBTime - safeATime;
    });

    return arr;
  }, [filteredContracts, dueSortDir]);

  // compute pagination (after sorting)
  const totalPages = Math.ceil(sortedContracts.length / pageSize);
  const startIndex = (currentPage - 1) * pageSize;
  const endIndex = startIndex + pageSize;
  const currentContracts = sortedContracts.slice(startIndex, endIndex);


  const [showActive, setShowActive] = useState(true);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [openModalId, setOpenModalId] = useState(null);
  const [notesIdOpen, setNotesIdOpen] = useState(null);
  const [totalPrice, setTotalPrice] = useState(0);
  const [count, setCount] = useState(0);
  // const userData = useUserData();
  const [pendingShifts, setPendingShifts] = useState([]);
  const [showShiftPrompt, setShowShiftPrompt] = useState(false);
  const apiUrl = process.env.REACT_APP_API_URL;
  const api = `${apiUrl}/contracts_crud.php`;
  const [inspectionContractId, setInspectionContractId] = useState(null);
  const [showInspectionModal, setShowInspectionModal] = useState(false);
  const months = [
      { name: 'All', value: 'all' },
      { name: 'January', value: '01' },
      { name: 'February', value: '02' },
      { name: 'March', value: '03' },
      { name: 'April', value: '04' },
      { name: 'May', value: '05' },
      { name: 'June', value: '06' },
      { name: 'July', value: '07' },
      { name: 'August', value: '08' },
      { name: 'September', value: '09' },
      { name: 'October', value: '10' },
      { name: 'November', value: '11' },
      { name: 'December', value: '12' },
  ];
  const handleSchedulerClick = () => {
    navigate('/inspection_calendar', { state: { contracts, apiUrl } });
  };
  const currentYear = new Date().getFullYear();
  const [currentMonth, setCurrentMonth] = useState(() => {
     // Initialize to the current month
       const date = new Date();
      return String(date.getMonth() + 1).padStart(2, '0');
  });
  const [showActualHrsModal, setShowActualHrsModal] = useState(false);
  const [actualHrsContractId, setActualHrsContractId] = useState(null);

  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [contractToDeactivate, setContractToDeactivate] = useState(null);
  const [file, setFile] = useState(null);
  const [selectGenFile, setSelectGenFile] = useState(null);
  const [isModalFileGenOpen, setIsModalFileGenOpen] = useState(false);
  const [totalHours, setTotalHours] = useState(0);
  const [contractsNoinspection, setContractsNoinspection] = useState([]);
  const [completedContracts, setCompletedContracts] = useState(null);

  //add new contact modal
  const [showAddContactModal, setShowAddContactModal] = useState(false);
  const [selectedContractId, setSelectedContractId] = useState(null);
  
  // This holds the list of contacts for the selected contract
  const [contactList, setContactList] = useState([]);

  const toggleDueSort = () => {
    setDueSortDir(prev => (prev === 'asc' ? 'desc' : 'asc'));
    setCurrentPage(1); // optional, but recommended so user sees the top of the sorted list
  };

  // This function opens the confirm modal
  const handleDeactivateClick = (contractId, currentStatus) => {
    setShowConfirmModal(true);
    // store the contract ID and its current status in state
    setContractToDeactivate({ id: contractId, status: currentStatus });
  };

    // When user actually confirms "Deactivate" in the modal
  const handleConfirmDeactivate = () => {
    if (contractToDeactivate) {
      voidContractSubmit(contractToDeactivate.id, contractToDeactivate.status);
    }
    setShowConfirmModal(false);
    setContractToDeactivate(null);
  };

    // When user cancels
  const handleCancelDeactivate = () => {
    setShowConfirmModal(false);
    setContractToDeactivate(null);
  };

  useEffect(() => {
    const savedTerm = sessionStorage.getItem('contractsSearchTerm');
    const savedList = sessionStorage.getItem('contractsFiltered');
    const savedActive = sessionStorage.getItem('contractsShowActive');

    if (savedTerm) {
      setSearchTerm(savedTerm);
    }

    if (savedActive !== null) {
      setShowActive(JSON.parse(savedActive));
    }

    if (savedList) {
      const list = JSON.parse(savedList);
      // ✔️ restore both states so the UI and logic have the same data
      setFilteredContracts(list);
      setContracts(list);
      setLoading(false);
    } else {
      // no saved filter → fetch fresh
      fetchDueContracts();
    }
  }, []);

  useEffect(() => {
    // fetchDueContracts(); commented out to avoid double fetch and for the saved search term to work
    fetchPendingShifts();
    fetchContractsNoInspeciton();
  }, []);

  const handleMonthChange = (monthValue) => {
    setCurrentMonth(monthValue);
    fetchDueContracts(monthValue);
  };

  const fetchDueContracts = async (selectedMonth = currentMonth, selectedYear = currentYear) => {
  setLoading(true);
  try {
    const response = await axios.get(api, {
      params: {
        getDueContracts: 'getDueContracts',
        month: selectedMonth,
        year: selectedYear,
      },
    });
    
      if (response.data) {
        setContracts(response.data[0]);
        setFilteredContracts(response.data[0]);
        setCount(response.data[1]);
        setTotalPrice(response.data[2]);
        setTotalHours(response.data[3]);
        setCompletedContracts(response.data[4]);
      } else {
        toast.error('Error fetching due contracts', { position: 'top-center' });
      }
    } catch (error) { 
        // Handle errors as in your existing code
        if (error.response && error.response.status === 401) {
          navigate('/login');
        } else if (error.response && error.response.status === 403) {
          toast.error("Oops!! You don't have access to this area. Speak to the CFO.", { position: "top-center" });
        } else {
          toast.error("Error fetching due contracts", { position: 'top-center' });
        }
      } finally {
        setLoading(false);
      }
  };

  const fetchContractsNoInspeciton = async () => {
    setLoading(true);
    try {
      const response = await axios.get(api, {
        params: { getContractsNoInsp: true},
      });
      if (response.data[0] === 'success') {
        setContractsNoinspection(response.data[1]);
      } 
      } catch (error) { 
          // Handle errors as in your existing code
          if (error.response && error.response.status === 401) {
            navigate('/login');
          } 
        } finally {
          setLoading(false);
      }
  };  

  const fetchPendingShifts = async () => {
    try {
      const response = await axios.get(api, { params: { getPendingShift: 'getPendingShift' } });
      if (response.data && response.data.length > 0) {
        setPendingShifts(response.data);
        setShowShiftPrompt(true);
      }
    } catch (error) {
      console.error('Error fetching pending shifts', error);
    }
  };

  const handleShiftDueDates = async (contractId) => {
    try {
      const response = await axios.post(api, {
        status: 'shiftDueDates',
        data: { contract_id: contractId }
      }, {
        headers: { 'Content-Type': 'application/json' }
      });
      if (response.data.success) {
        toast.success('Due dates shifted successfully', { position: 'top-center' });
        // Refresh the data
        fetchDueContracts();
        fetchPendingShifts();
      } else {
        toast.error(response.data.error || 'Error shifting due dates', { position: 'top-center' });
      }
    } catch (error) {
      console.error('Error shifting due dates', error);
      toast.error('Error shifting due dates', { position: 'top-center' });
    }
  };

  const handleKeepOriginalSchedule = (contractId) => {
    // Optionally, update the contract to not prompt again
    setPendingShifts(prev => prev.filter(contract => contract.id !== contractId));
    if (pendingShifts.length === 1) {
      setShowShiftPrompt(false);
    }
  };

  const handleRecordInspection = (contractId) => {
    setInspectionContractId(contractId);
    setShowInspectionModal(true);
  };  

  const submitInspection = async (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);
    const scheduled_due_date = formData.get('scheduled_due_date');
    const actual_inspection_date = formData.get('actual_inspection_date');
    const technician_id = formData.get('technician_id') || null;

    try {
      const response = await axios.post(api, {
        status: 'recordInspection',
        data: {
          contract_id: inspectionContractId,
          scheduled_due_date,
          actual_inspection_date,
          technician_id
        }
      }, {
        headers: { 'Content-Type': 'application/json' }
      });
      if (response.data.success) {
        toast.success('Inspection recorded successfully', { position: 'top-center' });
        // Close the modal and refresh data
        setShowInspectionModal(false);
        fetchDueContracts();
        fetchPendingShifts();
      } else if (response.data.warning) {
        toast.warning(response.data.warning, { position: 'top-center' });
        // Possibly show the shift prompt
        fetchPendingShifts();
      } else {
        toast.error(response.data.error || 'Error recording inspection', { position: 'top-center' });
      }
    } catch (error) {
      console.error('Error recording inspection', error);
      toast.error('Error recording inspection', { position: 'top-center' });
    }
  };
  
  const toggleShowVoid = () => {
    setShowActive(!showActive);
  };

const handleSearchChange = (event) => {
  const value = event.target.value;
  const search = value.trim().toLowerCase();

  setSearchTerm(value);
  setCurrentPage(1);

  // Clearing the search restores the currently loaded contracts.
  if (!search) {
    setFilteredContracts(contracts);
    return;
  }

  const filtered = contracts.filter((contract) => {
    const details = contract?.contract_details ?? {};

    return [
      details.job_site_address,
      details.job_site_address2,
      details.job_site_city,
      details.job_site_state,
      details.job_site_zip,
      contract?.customer_name,
      details.contract_type,
    ].some((field) =>
      String(field ?? '').toLowerCase().includes(search)
    );
  });

  setFilteredContracts(filtered);
};

  const handleSearchClick = async () => {
    setLoading(true);
    const bodyData = {
      status: 'search',
      data: { search: searchTerm }
    };

    try {
      const response = await axios.post(api, bodyData, {
        headers: { 'Content-Type': 'application/json' }
      });
      if (response.data && Array.isArray(response.data)) {
        setContracts(response.data);
        setFilteredContracts(response.data);
    // persist
        sessionStorage.setItem('contractsSearchTerm', searchTerm);
        sessionStorage.setItem('contractsFiltered', JSON.stringify(response.data));
        sessionStorage.setItem('contractsShowActive', JSON.stringify(showActive));        
      } else {
        setFilteredContracts([]);
        toast.error('No results found for: ' + searchTerm, { position: 'top-center' });
      }
    } catch (error) {
      console.error('Error searching contracts', error);
      toast.error('Error searching contracts', { position: 'top-center' });
    } finally {
      setLoading(false);
    }
  };

  const handleNotes = (contractId) => {
    setOpenModalId(contractId);
  };

  const handleChange = (event, id, user) => {
    const { name, value } = event.target;
    setFilteredContracts(prev => prev.map(contract => {
      if (parseInt(contract.id) === id) {
        const updatedContract = { ...contract, [name]: value };
        updatedContract.employee_name = `${user.first_name} ${user.last_name}`;
        return updatedContract;
      } else {
        return contract;
      }
    }));
  };

  const handleComplete = async (id) => {
    try {
      await axios.post(api, { status: 'submit_complete', id }, {
        headers: { 'Content-Type': 'application/json' }
      });

      toast.info('Contract marked as complete!', { position: 'top-center' });
      // Update the contract's status locally
      setFilteredContracts(prev => prev.map(contract => {
        if (contract.id === id) {
          return { ...contract, status: 'complete' };
        } else {
          return contract;
        }
      }));
    } catch (error) {
      console.error('Error updating contract', error);
      toast.error('Error updating contract', { position: 'top-center' });
    }
  };

  const voidContractSubmit = async (id, currentStatus) => {
    setLoading(true);
    const newStatusActive = currentStatus === 1 ? 0 : 1;
    const bodyData = {
      status: 'active',
      data: { contract_id: id, status: newStatusActive }
    };
    try {
      const response = await axios.post(api, bodyData, {
        headers: { 'Content-Type': 'application/json' }
      });
      if (response.data.success) {
        setFilteredContracts(prev =>
          prev.filter(contract => contract.contract_details.id !== id)
        );
        
        // setFilteredContracts(prev => prev.map(contract => {
        //   if (contract.contract_details.id === id) {
        //     return { ...contract, contract_details: { status: newStatusActive } };
        //   }
        //   return contract;
        // }));
        toast.success('Contract status updated!', { position: 'top-center' });
      } else {
        toast.error('Error updating contract', { position: 'top-center' });
      }
    } catch (error) {
        if (error.response && error.response.status === 401) {
        navigate('/login');
        } else if (error.response && error.response.status === 403) {
        toast.error("Oops!! you don't have access to this area. Speak to the CFO.", {
        position: "top-center"
        });
        }
    } finally {
      setLoading(false);
    }
  };

  // 2) Handler to open the modal
  const handleActualHrsClick = (contractId) => {
    setActualHrsContractId(contractId);
    setShowActualHrsModal(true);
  };

  // 3) Form submission
  const submitActualHrs = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const enteredHrs = formData.get('actual_hours');

    try {
      const response = await axios.post(api, {
        status: 'updateActualHours',
        data: {
          contract_id: actualHrsContractId,
          actual_hours: enteredHrs
        }
      }, {
        headers: { 'Content-Type': 'application/json' }
      });
      if (response.data.success) {
        toast.success('Actual hours updated!', { position: 'top-center' });
        fetchDueContracts();
      } else {
        toast.error(response.data.error || 'Error updating actual hours', { position: 'top-center' });
      }
    } catch (error) {
      console.error('Error updating actual hrs', error);
      toast.error('Error updating actual hours', { position: 'top-center' });
    } finally {
      setShowActualHrsModal(false);
      setActualHrsContractId(null);
    }
  };

  // 4) getLinksForContract updated to open the new modal
  const getLinksForContract = (contract) => 
  [
    { name:'Edit Contract',     click: () => navigate(`/maintenance_contract/edit/${contract?.id}`) },
    { name:'Update Actual Hrs', click: () => handleActualHrsClick(contract.id) },
    { name:'Upload File',       click: () => {setIsModalFileGenOpen(true); setSelectGenFile(contract.id); }, key: `void-${contract.id}` },
    { name:'Add Contacts',      click: () => handleAddContactClick(contract.id)  },
    (contract.contract_hold_amount && contract.contract_hold_amount > 0
      ? { name:'Remove Hold', click: () => handleRemoveHold(contract.id) }
      : { name:'Add Hold',    click: () => handleAddHoldClick(contract.id) }
    ),
    { name:contract.status === 1 ? 'Deactivate Contract' : 'Activate Contract',  click: () => handleDeactivateClick(contract.id, contract.status) },
  ];

  function DateFormat({ date }) {
    if (!date) {
      return <span>No Date</span>;
    }

    // Parse 'YYYY-MM-DD' as a plain local date
    const parsed = parse(date, 'yyyy-MM-dd', new Date());
    
    if (Number.isNaN(parsed.getTime())) {
      return <span>Invalid Date</span>;
    }

    // Format as "July 26, 2025"
    const display = format(parsed, 'M/d/yyyy');
    
    return <span>{display}</span>;
  }

  //Handler to open the file upload modal
  const handleGenUploadFile = async (e) => {
    e.preventDefault();
    if (!file) {
      toast.error("Please select a file before uploading.", { position: 'top-center' });
      return;
    }
    
    const formData = new FormData();
    formData.append('status', 'submit_gen_file');
    formData.append('id', selectGenFile); // Contract ID
    formData.append('file', file);
    
    try {
      const response = await axios.post(`${apiUrl}/maintenance_contract_file.php`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      
      if (response.data.success) {
        toast.info('File uploaded successfully!', { position: 'top-center' });

        // Update the state with the new file information
        setFilteredContracts(prevItems =>
        prevItems.map(item => {
          return item.contract_details.id === selectGenFile ? { ...item, contract_details:{...item.contract_details, file: response.data[0]}}: item
        } ));

        setFile(null);
        setIsModalFileGenOpen(false);
      } else {
        toast.error(response.data.error || "Error uploading file", { position: 'top-center' });
      }
    } catch (error) {
      toast.error("An error occurred during file upload.", { position: 'top-center' });
      //console.error('Error uploading file', error);
    }
  };

  //handle file change
  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (!selectedFile) {
      toast.error("No file selected.", { position: 'top-center' });
      setFile(null);
      return;
    }

    const validFileTypes = ['application/pdf'];
    const maxSize = 10 * 1024 * 1024; // 2MB in bytes

    if (!validFileTypes.includes(selectedFile.type)) {
      toast.error("Invalid file type. Only PDF is allowed.", { position: 'top-center' });
      setFile(null);
      return;
    }

    if (selectedFile.size > maxSize) {
      toast.error("File size exceeds 2MB.", { position: 'top-center' });
      setFile(null);
      return;
    }

    setFile(selectedFile);
  };  

  const exportToCSV = () => {
      if (!filteredContracts.length) {
        toast.warning('No data to export.', { position: 'top-center' });
        return;
      }

      // helper to escape & quote any value
      const quote = (val) => {
        if (val == null) return '""';
        const str = String(val)
          // escape inner quotes
          .replace(/"/g, '""')
          // replace any CR/LF/newlines with a space (or you could replace with literal '\n')
          .replace(/(\r\n|\n|\r)/gm, ' ');
        return `"${str}"`;
      };

      // build header
      let csv = [
        ['MID','Contract Type','Job Site','Customer','Price','NextDueDate',
              'Auto Renew','Exp Date','T-Hours','A-Hours','Notes', 'Signed Date', 'Last Inspection Date']
      ].map(r => r.join(',')).join('\n') + '\n';

      // build rows
      filteredContracts.forEach((c) => {
        const cd = c.contract_details || {};
        const row = [
          c.maintenance_id,
          quote(cd.contract_type),
          quote(cd.job_site_address + ' ' + cd.job_site_city + ' ' + cd.job_site_state),
          quote(c.customer_name),
          cd.current_price || 0,
          quote(c.next_due_date),
          cd.auto_renew === 1 ? 'Y' : 'N',
          quote(cd.exp_date_contract),
          quote(cd.hours),
          quote(cd.actual_hours),
          quote(cd.notes),
          quote(cd.signed_date),
          quote(cd.last_inspection_date)
        ];
        csv += row.join(',') + '\n';
      });

      // trigger download
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `contracts_export_${Date.now()}.csv`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
  };

  // 2) Form submission for adding contact
  const submitAddContact = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);

    const contact_name = formData.get('contact_name');
    const contact_phone = formData.get('contact_phone');
    const contact_email = formData.get('contact_email');

    if (!selectedContractId) {
      toast.error('No contract selected!', { position: 'top-center' });
      return;
    }

    try {
      const response = await axios.post(api, {
        status: 'addContact',
        data: {
          maintenance_id: selectedContractId,
          contact_name,
          contact_phone,
          contact_email
        }
      });

      if (response.data.success && response.data.newContact) {
        toast.success('Contact added!', { position: 'top-center' });

        // Option A: push the new contact into contactList state
        setContactList((prev) => [...prev, response.data.newContact]);

        // Clear the form
        e.target.reset();
      } else {
        toast.error(response.data?.error || 'Error adding contact', { position: 'top-center' });
      }
    } catch (error) {
      console.error('Error adding contact', error);
      toast.error('Error adding contact', { position: 'top-center' });
    }
  };

  const handleAddContactClick = async (contractId) => {
    setSelectedContractId(contractId);
    setShowAddContactModal(true);

    // Fetch existing contacts for that contract
    try {
      const response = await axios.get(api, {
        params: {
         getContactsByMaintenanceId: contractId
        }
      });
      if (response.data?.success && Array.isArray(response.data.contacts)) {
        setContactList(response.data.contacts);
      } else {
        setContactList([]);
        // toast.error(response.data?.error || 'Error fetching contacts', { position: 'top-center' });
      }
    } catch (error) {
      console.error('Error fetching contacts', error);
      toast.error('Error fetching contacts', { position: 'top-center' });
      setContactList([]);
    }
  };

  const handleDeleteContact = async (contactId) => {
    // if (!window.confirm("Are you sure you want to delete this contact?")) {
    //   return;
    // }
    try {
      const response = await axios.post(api, {
        status: 'deleteContact',
        data: { contact_id: contactId }
      });

      if (response.data.success) {
        toast.success('Contact deleted!', { position: 'top-center' });
        // Remove it from the local contactList
        setContactList((prev) => prev.filter((c) => c.id !== contactId));
      } else {
        toast.error(response.data?.error || 'Error deleting contact', { position: 'top-center' });
      }
    } catch (error) {
      console.error('Error deleting contact', error);
      toast.error('Error deleting contact', { position: 'top-center' });
    }
  };

  const handleReset = () => {
    sessionStorage.removeItem('contractsSearchTerm');
    sessionStorage.removeItem('contractsFiltered');
    sessionStorage.removeItem('contractsShowActive');

    setSearchTerm('');
    // reset filtered → full list
    setFilteredContracts(contracts);
    setShowActive(true);
    fetchDueContracts();
  };

  //hold modal
  const handleAddHoldClick = (contractId) => {
    setHoldContractId(contractId);
    setShowHoldModal(true);
  };

  // 1) Form submission for adding hold
  const submitAddHold = async (e) => {
  e.preventDefault();
  const formData = new FormData(e.target);
  const hold_amount = parseFloat(formData.get('hold_amount') || 0);

  if (!holdContractId || hold_amount <= 0) {
    toast.error('Enter a valid dollar amount.', { position:'top-center' });
    return;
  }

  try {
    const res = await axios.post(api, {
      status : 'addHold',
      data   : { contract_id: holdContractId, contract_hold_amount: hold_amount }
    }, { headers:{ 'Content-Type':'application/json' } });

    if (res.data?.success) {
      toast.success('Hold saved!', { position:'top-center' });

      // update UI – mark the contract as on-hold and keep the amount
      setFilteredContracts(prev =>
        prev.map(c =>
          c.maintenance_id === holdContractId
            ? {
                ...c,
                contract_details: {
                  ...c.contract_details,
                  contract_hold : 1,
                  contract_hold_amount: hold_amount,
                  contract_hold_date  : res.data.date_on_hold   // if backend returns it
                }
              }
            : c
        )
      );
      setShowHoldModal(false);
      setHoldContractId(null);
    } else {
      toast.error(res.data?.error || 'Could not save hold.', { position:'top-center' });
    }
  } catch (err) {
    toast.error('Server error.', { position:'top-center' });
  }
  };

  const handleRemoveHold = async (contractId) => {
    try {
      const res = await axios.post(api, {
        status : 'removeHold',
        data   : { contract_id: contractId }
      }, { headers:{ 'Content-Type':'application/json' } });

      if (res.data?.success) {
        toast.info('Hold removed.', { position:'top-center' });

        // flip the local state
        setFilteredContracts(prev =>
          prev.map(c =>
            c.maintenance_id === contractId
              ? { ...c,
                  contract_details:{
                    ...c.contract_details,
                    contract_hold_amount : null,
                    contract_hold_date   : null,
                    contract_last_off_hold_date : res.data.date_off_hold   // if your backend returns it
                  }
                }
              : c
          )
        );
      } else {
        toast.error(res.data?.error || 'Could not remove hold.', { position:'top-center' });
      }
    } catch (err) {
      toast.error('Server error.', { position:'top-center' });
    }
  };


  return (
    <div className="mx-auto max-w-[1250px] px-4 sm:px-6 lg:px-8 py-8">
      <h1 className="text-2xl font-semibold text-gray-500 mb-8">
        <HeadingCp label="Maintenance Dashboard" />
      </h1>

      <LegendCP color="fill-red-300" label="Void" />
      <LegendCP color="fill-blue-600" label="Due Date Shifted" />
      <LegendCP color="fill-red-600" label="Missing Due (ID)" />
      <LegendCP color="fill-blue-400" label="Additional Contacts" />
      <br />

      {/* Include the MonthTabs component */}
      <MonthTabs
        months={months}
        currentMonth={currentMonth}
        onMonthChange={handleMonthChange}
      />    
      <br />
      <br />
      <>{/*codex-- Match the updated toolbar: grouped actions, labeled controls, and lighter original colors. */}
        <PageToolbar title="Maintenance contract tools" actions={<>
          <button onClick={() => navigate(`/maintenance_contract/new/new`)} className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-orange-400 hover:bg-orange-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-black-500">
            <PlusIcon className="h-5" aria-hidden="true" />New contract</button>
          <button onClick={() => navigate(`/inspection_active`)} className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-red-600 hover:bg-red-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-black-500">Inactivate</button>
          <button onClick={exportToCSV} className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-orange-600 hover:bg-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-black-500">Export CSV</button>
          <button onClick={handleSchedulerClick} className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-black-500">Scheduler</button>
          <button onClick={() => navigate(`/maintenance_inspections`)} className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-green-600 hover:bg-green-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-black-500">Inspections</button>
        </>}>
          <div className="page-toolbar-search">
            <ToolbarField label="Search contracts"><input type="text" name="search" value={searchTerm} required placeholder="Enter a search term" onChange={handleSearchChange} onKeyDown={e => {
                if (e.key === 'Enter') {
                  e.preventDefault();
                  handleSearchClick(); // trigger search on Enter
                }
              }} className="block w-full pl-7 pr-12 sm:text-sm border-gray-300 rounded-md" /></ToolbarField>
            <button onClick={handleSearchClick} disabled={!searchTerm} className={`    text-white px-3 py-2 ${!searchTerm ? 'bg-gray-500' : 'bg-green-600 hover:bg-green-700'}`}>Search</button>
            <button onClick={handleReset} className="absolute right-0 top-0 bottom-0 bg-orange-600 hover:bg-orange-700 text-white px-3 py-2 rounded-r-md">
              <span className="flex items-center gap-1">
                <ArrowPathIcon className="h-5" />Reset</span>
            </button>
          </div>
        </PageToolbar>
      </>

      {loading ? (
        <LoadingSpinner>Loading...</LoadingSpinner>
      ) : (
          <>
            {loading && <LoadingSpinner />}
            {contractsNoinspection.length >= 1 && (
              <>
                <p className='font-semibold text-sm p-3'>Contract to be schedule | New</p>
                <div className='flex justify-between items-center mb-4 text-sm bg-yellow-50 p-2 rounded-lg'>                  
                  <ul>
                    {contractsNoinspection.map((contract) => {
                      if (contract.last_inspection_date === null || contract.last_inspection_date === '0000-00-00') {
                        return (
                          <li key={contract.id}>
                            <div className="flex items-center justify-start space-x-2 border-b border-gray-300 p-1">
                              <span>* {contract.id} | </span>
                              <span>{contract.signed_date} | </span>
                              <span>{contract.job_site_address}</span>
                              <span>{contract.job_site_city}</span>
                              <span className='text-gray-400'>| {contract.customer_name}</span>
                            </div>
                          </li>
                        );
                      }
                      return null;
                    })}
                  </ul>
                </div>
              </>
            )}          
            <div className='font-extrabold text-green-700 text-md'>
              {count} Contracts | <CurrencyFormat value={totalPrice}/> | {Math.ceil(totalHours)} Hrs | {completedContracts?.total_hours} Hrs Completed
            </div>
            <table className="min-w-full divide-y divide-gray-300 bg-gray-200 border rounded-lg">
              <thead>
                <tr className="divide-x divide-gray-400">
                  {[
                    'ID/Edit',
                    'Job-Site/Customer',
                    'PF',
                    'System Type',
                    'Price | renewal rate',
                    'Contact',
                    'N/F',
                    'Signed | Exp.',
                    'NI|LI',
                    'Due Hrs | Actual Hrs',
                ].map((header, index) => {
                  const isNiLi = header === 'NI|LI';

                  return (
                    <th
                      key={index}
                      scope="col"
                      className={`px-3 py-3.5 text-left text-sm font-semibold text-gray-900 ${
                        isNiLi ? 'cursor-pointer select-none hover:text-blue-700' : ''
                      }`}
                      onClick={isNiLi ? toggleDueSort : undefined}
                      title={isNiLi ? 'Sort by Next Due Date' : undefined}
                    >
                        {header}
                      {isNiLi && (
                        <span className="ml-2 text-xs text-gray-500">
                          {dueSortDir === 'asc' ? '▲' : '▼'}
                        </span>
                      )}
                      </th>
                  );
                })}
                </tr>
              </thead>
              <tbody>
              {currentContracts.map((contract, index) => {
                    const isOverdue = new Date(contract.next_due_date) < new Date();
                    const rowClassName = () => {
                        if (isOverdue) {
                          return 'bg-red-100 divide-x';
                        } else if (contract.contract_details.due_dates_shifted == 1) {
                          return 'bg-blue-100 divide-x';
                        } else {
                          return `${index % 2 === 0 ? 'bg-white' : 'bg-gray-100'} divide-x`;
                        }
                    };

                  return (
                    <tr key={contract.maintenance_id} className={rowClassName()}>
                    <td className="w-full max-w-0 py-4 pl-4 pr-3 text-sm font-medium text-gray-700 sm:w-auto sm:max-w-none sm:pl-2">
                      {contract.contract_details.status === 0 && (
                        <Badge color={'yellow'} feed={'Inactive'} />
                      )} 
                      <SubMenu label={contract.maintenance_id} 
                              links={getLinksForContract(contract.contract_details)} 
                              idItem={contract.maintenance_id} />
                      <span className="text-gray-400 text-xs">{contract.contract_details.contract_type}</span>
                    </td>

                    {/* job site address and customer name */}
                    <td className="px-3 py-4 text-sm text-gray-500">
                        <span className='font-bold text-black'>
                            {contract.contract_details.contract_hold_amount && (
                                <div className='text-red-600 text-xs p-1 bg-yellow-50'>
                                  On hold-owed: <CurrencyFormat value={contract.contract_details.contract_hold_amount} />
                                </div>
                            )}
                            {contract.contract_details.job_site_address}
                            {contract.contract_details.job_site_city && (' '+ contract.contract_details.job_site_city + ', ')} 
                            {contract.contract_details.job_site_state && (' '+ contract.contract_details.job_site_state + ' ')} 
                            {contract.contract_details.job_site_zip && (' '+ contract.contract_details.job_site_zip)} 
                        </span>
                      <p className="text-sm text-gray-500">
                        {contract.contract_details.job_site_address2 && (' ('+ contract.contract_details.job_site_address2 + ')')} 
                      </p>
                      <p className="text-sm text-gray-400">
                        {contract.customer_name} {contract.contract_details.hold === 1 && (<Badge color={'pink'} feed={"On Hold"}/>)}
                      </p>
                    </td>

                    {/* frequency */}
                    <td className="px-3 py-4 text-sm text-gray-500">
                      {contract.contract_details.frequency === 12
                        ? '(A)'
                        : contract.contract_details.frequency === 3
                        ? '(Q)'
                        : contract.contract_details.frequency === 1
                        ? '(M)'
                        : contract.contract_details.frequency === 6
                        ? '(SA)'
                        : ''}
                      <span className="pr-1">{contract.start_year}</span>
                      <span>{contract.term_begins}</span>
                    </td>
                    
                    {/* system type */}
                    <td className="px-3 py-4 text-sm text-gray-500">
                      {contract.contract_details.system_type}
                    </td>
                    
                    {/* price | renewal */}
                    <td className="px-3 py-4 text-sm text-gray-500">
                      {contract.contract_details.current_price ? <CurrencyFormat value={contract.contract_details.current_price} /> : 'N/A'}
                      {contract.contract_details.renewal_rate > 0 && (
                        <div><Badge  feed={contract.contract_details.renewal_rate+'% Rate'} color={'green'} num={'700'}/></div>
                      )}
                    </td>
                    
                    {/* contact */}
                    <td className="px-3 py-4 text-sm text-gray-500 max-w-[260px] whitespace-normal break-words">
                      {(() => {
                        const primaryName =
                          contract.contact_name ??
                          contract.contract_details?.contact_name ??
                          "";

                        const primaryPhone =
                          contract.contact_phone ??
                          contract.contract_details?.contact_phone ??
                          "";

                        const primaryEmail =
                          contract.contact_email ??
                          contract.contract_details?.contact_email ??
                          "";

                        const additionalContacts = Array.isArray(contract.contract_details.additional_contacts)
                          ? contract.contract_details.additional_contacts
                          : (Array.isArray(contract.contract_details.contact_list) ? contract.contract_details.contact_list : []);

                        return (
                          <td className="px-3 py-4 text-sm text-gray-500 max-w-[260px] whitespace-normal break-words">
                            <span className="text-green-700">
                              {(primaryName || primaryPhone || primaryEmail) ? (
                                <>
                                  {primaryName && <>{primaryName}</>}
                                  {primaryPhone && (<><br />{primaryPhone}</>)}
                                  {primaryEmail && (<><br />{primaryEmail}</>)}
                                </>
                              ) : "—"}

                              {additionalContacts.length > 0 && (
                                <>
                                  {additionalContacts.map((c, idx) => (
                                    <div key={c.id ?? `${c.contact_email}-${idx}`} className="flex items-center justify-between">
                                      <div className='text-xs text-gray-900 bg-blue-50 rounded-md p-1'>
                                         {c.contact_name}
                                         {c.contact_phone && ` |  ${c.contact_phone}`}
                                         {c.contact_email && ` |  ${c.contact_email}`}
                                      </div>
                                    </div>
                                  ))}
                                </>
                              )}
                            </span>
                          </td>
                        );
                      })()}
                    </td>

                    {/* notes / file */}
                    <td className="px-3 py-4 text-sm text-gray-500">
                      {contract.contract_details.notes && (
                        <span
                          className="hover:cursor-pointer"
                          onClick={() => handleNotes(contract.maintenance_id)}
                        >
                          <PencilSquareIcon className="h-5 text-blue-500" />
                        </span>
                      )}
                      {openModalId === contract.maintenance_id && (
                        <ModalWindow
                          job={<div>{contract.contract_details.notes}</div>}
                          closeNotes={() => setOpenModalId(null)}
                        />
                      )}
                      <br/>
                      <FileLocation expFile={contract.contract_details.file} where="maintenance_files" />
                    </td>

                    {/* signed and expiration date */}
                    <td className="px-3 py-4 text-sm text-gray-500">
                      <p><DateFormat date={contract.contract_details.signed_date}/></p>
                      {/* <p>{DateFormat(contract.contract_details.signed_date)}</p> */}
                      <p className="text-xs text-gray-400">
                        {contract.contract_details.auto_renew === 1 ? (
                          'Auto-renew'
                        ) : (
                              <span className='text-red-800'>
                              {/* Ex: {DateFormat(contract.contract_details.exp_date_contract)} */}
                              Ex: <DateFormat date={contract.contract_details.exp_date_contract}/>
                      </span>
                        )}
                      </p>
                    </td>
                    
                    {/* next due date / last inspection */}
                    <td className="px-3 py-4 text-gray-500 text-sm">
                      <span>
                        {contract.next_due_date ? 
                            // DateFormat(contract.next_due_date)
                            <DateFormat date={contract.next_due_date}/>
                          : 'N/A'}
                      </span>
                      <span className='text-green-700'>
                        {contract.contract_details.last_inspection_date && (
                          <div className={`${contract.contract_details.last_inspection_date? (
                            new Date(contract.contract_details.last_inspection_date).getMonth() === currentMonth 
                                ? 'text-green-700 bg-rose-50 rounded p-1' : 'text-white bg-red-600 rounded p-1') 
                            : ('')}`}>
                          <DateFormat  date={contract.contract_details.last_inspection_date} />
                          </div>
                        )
                        }
                      </span>
                    </td>

                    {/* due hours / acutal hrs*/}
                    <td className="px-3 py-4 text-sm text-gray-500">
                      {contract.due_hours ? <>{contract.due_hours} Hrs </>: 'N/A'}
                      <p className='text-green-700'>{contract.contract_details.actual_hours ? `${contract.contract_details.actual_hours} AHrs` : 'N/A'}</p>
                    </td>
                  </tr>
                );
              })}
              </tbody>
            </table>
        
            {/* <-- NEW: pagination controls */}
            <div className="flex justify-center items-center mt-4 space-x-2">
              <button
                onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
                className="px-3 py-1 border rounded disabled:opacity-50"
              >
                Prev
              </button>
              <span>Page {currentPage} of {totalPages}</span>
              <button
                onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                disabled={currentPage === totalPages}
                className="px-3 py-1 border rounded disabled:opacity-50"
              >
                Next
              </button>

              {/* optional: change page size */}
              <select
                className="ml-4"
                value={pageSize}
                onChange={(e) => {
                  setPageSize(+e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="5">5</option>
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
            </div>            
          </>
      )}

      {showShiftPrompt && (
        <ModalWindow
          closeNotes={() => setShowShiftPrompt(false)}
          job={
            <div>
              <h2 className="text-lg font-semibold">Shift Due Dates</h2>
              {pendingShifts.map(contract => (
                <div key={contract.id} className="mb-4">
                  <p>
                    Contract <strong>{contract.id}</strong> for Customer <strong>{contract.customer_id}</strong> has an inspection completed late.
                  </p>
                  <p>
                    Scheduled Due Date: {DateFormat(contract.scheduled_due_date)}
                  </p>
                  <p>
                    Actual Inspection Date: {DateFormat (contract.actual_inspection_date)}
                  </p>
                  <button
                    onClick={() => handleShiftDueDates(contract.id)}
                    className="bg-blue-500 text-white px-4 py-2 rounded mt-2 mr-2"
                  >
                    Shift Due Dates
                  </button>
                  <button
                    onClick={() => handleKeepOriginalSchedule(contract.id)}
                    className="bg-gray-500 text-white px-4 py-2 rounded mt-2"
                  >
                    Keep Original Schedule
                  </button>
                </div>
              ))}
            </div>
          }
        />
      )}

      {showInspectionModal && (
        <ModalWindow
          closeNotes={() => setShowInspectionModal(false)}
          job={
            <div>
              <h2 className="text-lg font-semibold">Record Inspection for Contract {inspectionContractId}</h2>
              <form onSubmit={submitInspection}>
                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700">
                    Scheduled Due Date:
                    <input type="date" name="scheduled_due_date" required className="mt-1 block w-full" />
                  </label>
                </div>
                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700">
                    Actual Inspection Date:
                    <input type="date" name="actual_inspection_date" required className="mt-1 block w-full" />
                  </label>
                </div>
                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700">
                    Technician ID:
                    <input type="number" name="technician_id" className="mt-1 block w-full" />
                  </label>
                </div>
                <div className="flex justify-end">
                  <button type="button" onClick={() => setShowInspectionModal(false)} className="mr-2 px-4 py-2 bg-gray-500 text-white rounded">
                    Cancel
                  </button>
                  <button type="submit" className="px-4 py-2 bg-blue-500 text-white rounded">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          }
        />
      )}

        {/* 5) Render the new modal */}
      {showActualHrsModal && (
        <ModalWindow
          closeNotes={() => {
            setShowActualHrsModal(false);
            setActualHrsContractId(null);
          }}
          job={
            <div className="max-w-">
              <h2 className="text-lg font-semibold mb-4">
                Update Actual Hours For (Contract ID: {actualHrsContractId})
              </h2>
              <form onSubmit={submitActualHrs}>
                <div className="mb-4">
                  <label htmlFor="actual_hours" className="block text-sm font-medium text-gray-700">
                    Enter Actual Hours:
                  </label>
                  <input
                    type="number"
                    name="actual_hours"
                    id="actual_hours"
                    required
                    className="mt-1 block w-full border rounded p-1"
                  />
                </div>
                <div className="flex justify-end">
                  <button
                    type="button"
                    onClick={() => {
                      setShowActualHrsModal(false);
                      setActualHrsContractId(null);
                    }}
                    className="mr-2 px-4 py-2 bg-gray-500 text-white rounded"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="px-4 py-2 bg-blue-500 text-white rounded"
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          }
        />
      )}

        {/* file upload */}
      {isModalFileGenOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-600 bg-opacity-50">
          <div className="bg-white p-8 rounded-md shadow-md min-w-[500px]">
            <h2 className="text-xl font-semibold mb-4">Upload File</h2>
            <form onSubmit={handleGenUploadFile}>
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700">Select a PDF file (Max size 2MB)</label>
                <input
                  type="file"
                  accept="application/pdf"
                  onChange={handleFileChange}
                  className="mt-2"
                />
              </div>
              <div className="flex justify-end">
                <button
                  type="button"
                  onClick={() => setIsModalFileGenOpen(false)}
                  className="px-4 py-2 mr-2 bg-gray-300 text-gray-700 rounded hover:bg-gray-400"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-700"
                >
                  Upload
                </button>
              </div>
            </form>
          </div>
        </div>
      )}      

      <ConfirmDeleteModal
        isOpen={showConfirmModal}
        onConfirm={handleConfirmDeactivate}
        onCancel={handleCancelDeactivate}
        title={contractToDeactivate?.status === 1 ? 'Confirm Deactivate' : 'Confirm Activate'}
        message="Are you sure you want to change this contract's status?"
        itemName={contractToDeactivate ? `Contract ID: ${contractToDeactivate.id}` : ''}/>      

      {showAddContactModal && (
        <ModalWindow
          closeNotes={() => {
            setShowAddContactModal(false);
            setSelectedContractId(null);
            setContactList([]); 
          }}
          job={
            <div className="max-w-md">
              <h2 className="text-lg font-semibold mb-4">
                Add Contact to Contract #{selectedContractId}
              </h2>

              {/* CONTACT LIST */}
              <div className="mb-6">
                {contactList.length === 0 ? (
                  <p className="text-sm text-gray-500">
                    No contacts found for this contract.
                  </p>
                ) : (
                  <ul className="space-y-2">
                    {contactList.map((contact) => (
                      <li
                        key={contact.id}
                        className="flex justify-between items-center bg-gray-100 p-2 rounded"
                      >
                        <div>
                          <span className="font-medium text-gray-800">
                            {contact.contact_name}
                          </span>
                          <p className="text-sm text-gray-600">
                            {contact.contact_phone} | {contact.contact_email}
                          </p>
                        </div>
                        {/* TRASH ICON to delete this contact */}
                        <button
                          onClick={() => handleDeleteContact(contact.id)}
                          className="text-red-600 hover:text-red-800"
                        >
                          <svg
                            className="h-5 w-5"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth={2}
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M9 13h6M9 9h6m-7 4v7a2 2 0 002 2h6
                                a2 2 0 002-2v-7M5 7h14
                                M10 5h4
                                a2 2 0 012 2v0H8v0
                                a2 2 0 012-2z"
                            />
                          </svg>
                        </button>
                      </li>
                    ))}
                  </ul>
                )}
              </div>

              {/* ADD CONTACT FORM */}
              <form onSubmit={submitAddContact}>
                <div className="mb-4">
                  <label htmlFor="contact_name" className="block text-sm font-medium text-gray-700">
                    Contact Name
                  </label>
                  <input
                    type="text"
                    name="contact_name"
                    id="contact_name"
                    required
                    className="mt-1 block w-full border rounded p-1"
                  />
                </div>

                <div className="mb-4">
                  <label htmlFor="contact_phone" className="block text-sm font-medium text-gray-700">
                    Phone (10 digits)
                  </label>
                  <input
                    type="text"
                    name="contact_phone"
                    id="contact_phone"
                    required
                    className="mt-1 block w-full border rounded p-1"
                  />
                </div>

                <div className="mb-6">
                  <label htmlFor="contact_email" className="block text-sm font-medium text-gray-700">
                    Email
                  </label>
                  <input
                    type="email"
                    name="contact_email"
                    id="contact_email"
                    className="mt-1 block w-full border rounded p-1"
                  />
                </div>

                {/* MODAL BUTTONS */}
                <div className="flex justify-end">
                  <button
                    type="button"
                    onClick={() => {
                      setShowAddContactModal(false);
                      setSelectedContractId(null);
                      setContactList([]);
                    }}
                    className="mr-2 px-4 py-2 bg-gray-500 text-white rounded"
                  >
                    Close
                  </button>
                  <button
                    type="submit"
                    className="px-4 py-2 bg-blue-500 text-white rounded"
                  >
                    Add
                  </button>
                </div>
              </form>
            </div>
          }
        />
      )}

      {showHoldModal && (
        <ModalWindow
          closeNotes={() => { setShowHoldModal(false); setHoldContractId(null); }}
          job={
            <div className="max-w-sm">
              <h2 className="text-lg font-semibold mb-4">
                Add Hold – Contract&nbsp;#{holdContractId}
              </h2>

              <form onSubmit={submitAddHold}>
                <label className="block mb-4">
                  <span className="text-sm font-medium text-gray-700">Hold Amount ($)</span>
                  <input
                    type="number"
                    name="hold_amount"
                    step="0.01"
                    min="0"
                    required
                    className="mt-1 block w-full border rounded p-1"
                  />
                </label>

                <div className="flex justify-end">
                  <button
                    type="button"
                    onClick={() => { setShowHoldModal(false); setHoldContractId(null);} }
                    className="mr-2 px-4 py-2 bg-gray-500 text-white rounded">
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="px-4 py-2 bg-blue-500 text-white rounded">
                    Save
                  </button>
                </div>
              </form>
            </div>
          }
        />
      )}

    </div>
  );
};

export default ContractsPage;
